export default __webpack_public_path__ + "static/media/pin.231b4b46.svg";